import axios from "axios";
import constants from "../../../config/constants";

const USERNAME_KEY = "anniv2026-username";
const PASSWORD_KEY = "anniv2026-password";

// kept in memory too: localStorage may be unavailable (private browsing, blocked storage)
let credentials = {
    username: readStorage(USERNAME_KEY),
    password: readStorage(PASSWORD_KEY),
};

function readStorage(key) {
    try {
        return localStorage.getItem(key) || "";
    } catch (e) {
        return "";
    }
}

function writeStorage(key, value) {
    try {
        if (value) {
            localStorage.setItem(key, value);
        } else {
            localStorage.removeItem(key);
        }
    } catch (e) {
        // the session simply won't survive a reload
    }
}

export function getCredentials() {
    return {...credentials};
}

export function saveCredentials(username, password) {
    credentials = {username, password};
    writeStorage(USERNAME_KEY, username);
    writeStorage(PASSWORD_KEY, password);
}

export function clearCredentials() {
    saveCredentials("", "");
}

// every anniv2026 call sends the credentials in the body
export function post(path, body = {}) {
    return axios.post(constants.api.basePath + "/anniv2026" + path, {...credentials, ...body})
        .then(res => res.data);
}

export function errorMessage(err) {
    return (err.response && err.response.data && err.response.data.msg) || "Erreur réseau";
}
